import { Fragment, useRef } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceAddSection from "./InvoiceAddSection";
import InvoiceAmountSection from "./InvoiceAmountSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTable from "./InvoiceTable";

const Invoice3Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Container className="invoice-3 mb-4">
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card>
                <CardBody>
                  <Table borderless>
                    <tbody>
                      <InvoiceHead />
                      <InvoiceAddSection />
                      <InvoiceTable />
                      <InvoiceAmountSection />
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons contentRef={contentRef} />
    </Fragment>
  );
};

export default Invoice3Container;
